import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import { Box } from '@mui/material';

/* eslint-disable react/prop-types */
export default function ColumnStackedApexChart({ name, data }) {
  const [idname] = useState(name);
  const [renderChart, setRenderChart] = useState(false);
  const options = {
    series: data,
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        borderRadiusApplication: 'end', // 'around', 'end'
        borderRadiusWhenStacked: 'last', // 'all', 'last'
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: '13px',
              fontWeight: 900,
            },
          },
        },
      },
    },
    xaxis: {
      type: 'month',
      categories: [
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEPT',
        'OCT',
        'NOV',
        'DEC',
      ],
    },

    fill: {
      opacity: 1,
    },
  };

  useEffect(() => {
    if (renderChart) {
      const chart = new ApexCharts(document.querySelector(`#${idname}`), options);
      chart.render();
    }

    setRenderChart(true);
  }, [renderChart]);

  return (
    <Box
    // sx={
    //   data?.value.length > 25
    //     ? { height: '500px', overflowY: 'scroll', overflowX: 'hidden' }
    //     : { height: '500px' }
    // }
    >
      <div id={idname} />
    </Box>
  );
}
